import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { asyncLogout, logoutFromKeycloak } from 'services/reqres/requests'

function Logout() {
  const dispatch = useDispatch()

  useEffect(() => {
    const performLogout = async () => {
      try {// Adjust this to get the token from your storage
        await logoutFromKeycloak();
        dispatch(asyncLogout());
      } catch (error) {
        console.error('Error logging out:', error);
      }
    }
    //dispatch(asyncLogout())
    performLogout();
  }, [dispatch])
}

export default Logout
